<template>
  <DialogLayout :class-name="'interview-channel-dialog'" @close="handleClose">
    <template #title>{{ dialogTitle }}</template>
    <template #default>
      <el-form
        ref="formRef"
        :model="formData"
        :rules="rules"
        :label-position="'left'"
        class="channel-form"
      >
        <el-form-item :label="t('interviewChannel.channelName')" prop="name">
          <el-input
            v-model="formData.name"
            :placeholder="t('interviewChannel.channelNamePlaceholder')"
            maxlength="50"
          />
        </el-form-item>
        <el-form-item :label="t('interviewChannel.isEnabled')" prop="enabled">
          <div class="switch-desc">
            <el-switch v-model="formData.enabled" />
            <div class="enable-description">
              {{ formData.enabled ? t('interviewChannel.enabledDescription') : t('interviewChannel.disabledDescription') }}
            </div>
          </div>
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <el-button @click="handleCancel">
        {{ t('common.cancel') }}
      </el-button>
      <el-button type="primary" :loading="submitting" @click="handleConfirm">
        {{ confirmButtonText }}
      </el-button>
    </template>
  </DialogLayout>
</template>

<script setup lang="ts">
import { ref, reactive, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { FormInstance, FormRules } from 'element-plus';
import DialogLayout from '@/components/business-components/dialog/dialog-layout.vue';
import type { InterviewChannelModalProps } from './interview-channel-types';

const { t } = useI18n();

const props = withDefaults(
  defineProps<InterviewChannelModalProps>(),
  {
    enabled: true,
  }
);

const emit = defineEmits<{
  cancel: [];
  confirm: [data?: any];
  close: [];
}>();

const formRef = ref<FormInstance>();
const submitting = ref(false);

const dialogTitle = computed(() => {
  return props.id ? t('interviewChannel.editChannel') : t('interviewChannel.createChannel');
});

const confirmButtonText = computed(() => {
  return props.id ? t('interviewChannel.saveButton') : t('interviewChannel.addButton');
});

const formData = reactive({
  name: props.name || '',
  enabled: props.enabled,
});

const rules = reactive<FormRules>({
  name: [
    { required: true, message: t('interviewChannel.channelNameRequired'), trigger: 'blur' }
  ],
});

const handleCancel = () => {
  emit('cancel');
};

const handleConfirm = async () => {
  if (!formRef.value) return;

  try {
    await formRef.value.validate();
    submitting.value = true;

    // TODO: 调用接口保存数据
    console.log('Save channel:', formData, props);

    if (props.onAdd) {
      await props.onAdd(formData);
    }

    emit('confirm', formData);
  } catch (error) {
    console.error('Validation failed:', error);
  } finally {
    submitting.value = false;
  }
};

const handleClose = () => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.interview-channel-dialog {
  width: 620px;
  background: #ffffff;
}

.channel-form {
  :deep(.el-form-item) {
    margin-bottom: 20px;

    .el-form-item__label {
      font-size: 14px;
      font-weight: 600;
      line-height: 35px;
      margin-bottom: 8px;
      width: 121px;
    }
  }
  :deep(.el-switch) {
    height: 35px;
  }
}

.enable-description {
  font-size: 14px;
  color: #6C757D;
  line-height: 22px;
  margin-left: 4px;
  margin-top: 5px;
}
.switch-desc {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  :deep(.el-switch) {
    // height: ;
  }
}

</style>
